import { Base } from '@studiometa/js-toolkit';

/**
 * Toast component
 */
export default class Toast extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Toast',
  };

  /**
   *
   * @param {string} content
   */
  addToast(content) {
    // Ne pas afficher de toast vide (ex: réponse d'erreur sans `body.message`).
    if (typeof content !== 'string' || content.trim() === '') {
      return;
    }

    const toast = document.createElement('output');
    toast.textContent = content;
    toast.classList.add('toast');
    toast.setAttribute('role', 'status');

    this.$el.append(toast);
  }
}
